import React, { useEffect, useState } from 'react';
import { Toaster } from 'react-hot-toast';
import Portal from '../Portal';
const Toast = () => {
  const [theme, setTheme] = useState(() => {
    // Check both localStorage and DOM class for initial theme
    const storedTheme = localStorage.getItem('theme');
    const isDarkClass = document.documentElement.classList.contains('dark');
    return storedTheme || (isDarkClass ? 'dark' : 'light');
  });

  useEffect(() => {
    // Handle localStorage changes (cross-tab)
    const handleStorageChange = () => {
      setTheme(localStorage.getItem('theme') || 'light');
    };

    // Handle DOM class changes (same-tab theme switching)
    const handleDOMChange = () => {
      const isDark = document.documentElement.classList.contains('dark');
      const newTheme = isDark ? 'dark' : 'light';
      setTheme(newTheme);
    };

    // MutationObserver to watch for class changes on document.documentElement
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          handleDOMChange();
        }
      });
    });

    // Start observing
    observer.observe(document.documentElement, { attributes: true });

    // Listen for storage events (cross-tab changes)
    window.addEventListener('storage', handleStorageChange);

    // Cleanup
    return () => {
      observer.disconnect();
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const toastOptions = {
    light: {
      className: 'bg-gray-50 text-gray-700 border border-gray-200 shadow-sm rounded-xl px-4 py-2 text-sm font-medium text-left min-w-80 max-w-lg',
      duration: 4000,
      success: {
        duration: 3500,
        className: 'bg-gray-50 text-gray-700 border border-gray-200 shadow-sm rounded-xl px-4 py-2 text-sm font-medium text-left min-w-80 max-w-lg',
        iconTheme: {
          primary: '#16a34a', // green-600
          secondary: '#ffffff',
        },
      },
      error: {
        duration: 5000,
        className: 'bg-gray-50 text-gray-700 border border-gray-200 shadow-sm rounded-xl px-4 py-2 text-sm font-medium text-left min-w-80 max-w-lg',
        iconTheme: {
          primary: '#dc2626', // red-600
          secondary: '#ffffff',
        },
      },
      loading: {
        className: 'bg-gray-50 text-gray-700 border border-gray-200 shadow-sm rounded-xl px-4 py-2 text-sm font-medium text-left min-w-80 max-w-lg',
        iconTheme: {
          primary: '#9ca3af', // gray-400
          secondary: '#ffffff',
        },
      },
    },
    dark: {
      className: 'bg-gray-700 text-gray-200 border border-gray-600 shadow-lg rounded-xl px-4 py-2 text-sm font-medium text-left min-w-80 max-w-lg',
      duration: 4000,
      success: {
        duration: 3500,
        className: 'bg-gray-700 text-gray-200 border border-gray-600 shadow-lg rounded-xl px-4 py-2 text-sm font-medium text-left min-w-80 max-w-lg',
        iconTheme: {
          primary: '#10b981', // emerald-500
          secondary: '#ffffff',
        },
      },
      error: {
        duration: 5000,
        className: 'bg-gray-700 text-gray-200 border border-gray-600 shadow-lg rounded-xl px-4 py-2 text-sm font-medium text-left min-w-80 max-w-lg',
        iconTheme: {
          primary: '#ef4444', // red-500
          secondary: '#ffffff',
        },
      },
      loading: {
        className: 'bg-gray-700 text-gray-200 border border-gray-600 shadow-lg rounded-xl px-4 py-2 text-sm font-medium text-left min-w-80 max-w-lg',
        iconTheme: {
          primary: '#a0aec0', // gray-400 for dark
          secondary: '#ffffff',
        },
      },
    },
  };

  return (
    <Portal>
      <Toaster
        position="top-center"
        toastOptions={theme === 'dark' ? toastOptions.dark : toastOptions.light}
        containerStyle={{
          top: 10,
          left: 20,
          bottom: 20,
          right: 20,
          zIndex: 100000
        }}
        gutter={8}
      />
    </Portal>
  );
};

export default Toast; 